import { Typography } from '@mui/material'

export const NET_TYPE_MAP: Record<string, { letter: string; name: string }> = {
  lora: { letter: 'L', name: 'LoRa' },
  relay: { letter: 'R', name: 'Relay' },
  sidewalk: { letter: 'S', name: 'Sidewalk' },
}

const NetTypeBubble = ({ value, isOffline }: { value: string; isOffline: boolean }) => {
  const offlineText = isOffline ? ' (Offline)' : ''
  const netInfo = NET_TYPE_MAP[String(value).toLowerCase()]
  const letter = netInfo?.letter ?? '--'
  const name = netInfo?.name ?? 'Unknown'

  return (
    <Typography variant="body1" color={isOffline ? 'divider' : 'textPrimary'} aria-label={`${name}${offlineText}`}>
      {letter}
    </Typography>
  )
}

export default NetTypeBubble
